<template>
  <div>
    <DateTimePicker
      :label="label"
      @input="$emit('input', $event)"
      :value="value"
      style="margin-bottom: 10px"
      :rules="rules"
    ></DateTimePicker>
  </div>
</template>

<script>
export default {
  props: {
    value: [Date, String],
    label: String,
    rules: {
      type: Array,
      default: function () {
        return [];
      },
    },
    links: {
      type: Object,
      default: () => ({}),
    },
  },
};
</script>

<style scoped lang="scss"></style>
